import styled from '@emotion/styled';
import { borderRadii } from '__app/spacing';
import { KizenTypography } from '__app/typography';
import Button from '__components/Button';
import Switch from '__components/Kizen/Switch';
import css from '@emotion/css';
import Loader from '__components/Kizen/Loader';

export const StyledLoader = styled(Loader)`
  height: 100%;
  ${({ paddingTop = 0 }) => css`
    padding-top: ${paddingTop} !important;
  `};
`;

export const StyledAdditionalVariablesInfo = styled(KizenTypography)`
  background-color: var(--color-feedback-info-bg);
  padding: 10px;
  margin-bottom: 20px;
`;

export const StyledAddVariableButton = styled(Button)`
  margin: 0;
  margin-top: 2px;
  padding-left: 0;
`;

export const StyledAdditionalVariablesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const StyledVariableWarpper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const StyledVariableCard = styled.div<{ hasError: boolean }>`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 15px;
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--color-button-warning-default)'
        : 'var(--color-border-medium)'};
  border-radius: ${borderRadii.small};
`;

export const StyledRequiredSwitch = styled(Switch)`
  height: 100%;
  & > div {
    margin-bottom: 20px;
  }
`;

export const StyledDiv = styled.div<{ width: number }>`
  ${({ width }) => css`
    width: ${width}px;
  `}
`;

export const StyledBottomButtons = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const StyledNotice = styled(KizenTypography)`
  background-color: var(--color-feedback-info-bg);
  padding: 10px;
`;

export const StyledWrapper = styled.div`
  margin-top: 20px;
  padding-bottom: 400px;
`;
